import { render, staticRenderFns } from "./DownloadEntityComponent.vue?vue&type=template&id=d327e4fa&scoped=true"
import script from "./DownloadEntityComponent.vue?vue&type=script&lang=js"
export * from "./DownloadEntityComponent.vue?vue&type=script&lang=js"
import style0 from "./DownloadEntityComponent.vue?vue&type=style&index=0&id=d327e4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d327e4fa",
  null
  
)

export default component.exports